import {copyAnalysisViewSteps} from 'analysis-tool/AnalysisActions';
import {ARCHIVED_ANALYSIS_TOOLTIP_TEXT} from 'analysis-tool/AnalysisToolConstants';
import {AnalysisGraphQL, AnalysisViewGraphQL} from 'analysis-tool/AnalysisTypes';
import {OverflowDataViewAction} from 'analysis-tool/data-view/DataViewContext';
import isAnalysisReadOnly from 'analysis-tool/isAnalysisReadOnly';
import isArchived from 'archive/isArchived';
import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {withLoadingScreen} from 'util/Promises';

export default function getCopyViewAction(
  analysis: AnalysisGraphQL,
  view: AnalysisViewGraphQL
): OverflowDataViewAction | null {
  const firstStep = view.lineage[0].step;

  // TODO(BNCH-123748): Add support for generically copying any view.
  if (firstStep.stepType !== PipelineStepType.DATASET_VIEW || isAnalysisReadOnly(analysis)) {
    return null;
  }

  return {
    icon: 'copy',
    onClick: () => {
      withLoadingScreen(copyAnalysisViewSteps(analysis.id, view.lineage[0].step.id));
    },
    label: 'Copy view',
    isDisabled: isArchived(analysis),
    helpText: isArchived(analysis) ? ARCHIVED_ANALYSIS_TOOLTIP_TEXT : undefined,
  };
}
